import type { RadarData, RocadeWay, SubscribeRequest } from "@radarspotter/types";

export const WORKER_URL = import.meta.env.VITE_WORKER_URL;

/** URL de `GET /data`, aussi utilisée par le service worker pour son cache. */
export const DATA_URL = `${WORKER_URL}/data`;

export async function fetchData(signal: AbortSignal): Promise<RadarData> {
	const res = await fetch(DATA_URL, { signal });
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return res.json();
}

async function post(path: string, body: unknown) {
	return fetch(`${WORKER_URL}${path}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
}

/** Enregistre (ou met à jour) l'abonnement et les sens suivis. */
export async function saveSubscription(sub: PushSubscription, ways: RocadeWay[]) {
	const body: SubscribeRequest = { subscription: sub.toJSON() as SubscribeRequest["subscription"], ways };
	const res = await post("/subscribe", body);
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
}

/** Sens suivis par cet abonnement côté serveur, ou null s'il y est inconnu. */
export async function fetchSubscriptionWays(endpoint: string): Promise<RocadeWay[] | null> {
	const res = await post("/subscription", { endpoint });
	if (res.status === 404) return null;
	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return (await res.json()).ways;
}

export async function deleteSubscription(endpoint: string) {
	await post("/unsubscribe", { endpoint });
}
